<template>
  <div>
    <div class="clear">&nbsp;</div>
    <form id="store-user-invoice-actions">
      <table>
        <tr>
          <td>
            <label for="email">{{ $t('confirmation.store-user-invoice-actions.email-address') }}</label>
            <input id="email" v-model="email" class="email" type="text">
            <ul v-if="$v.email.$error" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
              <li v-if="!$v.email.required">{{ $t('confirmation.store-user-invoice-actions.validation.required') }}</li>
              <li v-if="!$v.email.email">{{ $t('confirmation.store-user-invoice-actions.validation.email') }}</li>
            </ul>
          </td>
          <td class="buttons">
            <input :value="$t('confirmation.button.send-confirmation')" type="submit" class="button small" @click.prevent="sendConfirmation()">
            <a class="button small print-invoice-link" href="javascript:void(0);" target="_blank" @click.prevent="printInvoice()">
              {{ $t('confirmation.button.print-invoice') }}
            </a>
          </td>
        </tr>
      </table>
    </form>
    <v-modal v-if="modalNotice != null"
             id="notificationModal"
             @close="modalNotice = null">
      <h2>&nbsp;</h2>
      <p>{{ modalNotice }}</p>
    </v-modal>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import { ORDER_SENT_RESULT_SUCCESS } from '../../order-api/order-api-client-constants'
import VModal from '../modals/Modal'

export default {
  name: 'StoreUserInvoiceActions',
  components: {
    VModal
  },
  mixins: [
    validationMixin
  ],
  props: {
    order: {
      type: Object,
      required: false,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      email: null,
      modalNotice: null
    }
  },
  validations () {
    return {
      email: {
        required,
        email
      }
    }
  },
  mounted () {
    if (this.order && this.order.customerDetails && this.order.customerDetails.emailAddress) {
      this.email = this.order.customerDetails.emailAddress
    }
  },
  methods: {
    sendConfirmation: async function () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const result = await this.$container.orderApiClient.sendInvoice(this.order.id, this.order.token, this.email)
        this.modalNotice = result.result === ORDER_SENT_RESULT_SUCCESS
          ? this.$t('confirmation.store-user-invoice-actions.email-sent-success')
          : this.$t('confirmation.store-user-invoice-actions.email-sent-failed')
      }
    },
    printInvoice: async function () {
      const URL = window.URL || window.webkitURL
      const popup = window.open(URL.createObjectURL(new Blob([this.$t('generic.loading')], { type: 'text/html' }), '_blank'))
      try {
        const pdf = await this.$container.orderApiClient.getInvoice(this.order.id, this.order.token)
        popup.location = URL.createObjectURL(new Blob([pdf], { type: 'application/pdf' }))
      } catch (error) {
        const errorMessage = this.$t('confirmation.store-user-invoice-actions.download-failed')
        this.modalNotice = errorMessage
        popup.location = URL.createObjectURL(new Blob([errorMessage], { type: 'text/html' }))
      }
    }
  }
}
</script>

<style scoped>
#store-user-invoice-actions {
  width: 100%;
}

#store-user-invoice-actions table {
  border: none;
  border-collapse: separate;
}

#store-user-invoice-actions table td.buttons {
  padding-top: 26px;
}

#store-user-invoice-actions input.email {
  width: 550px;
}
</style>



// WEBPACK FOOTER //
// src/components/payment-confirmation/StoreUserInvoiceActions.vue